export function getLDUserKey(env: string, userId: number) {
    return env + "::" + userId;
}

export function getLDWorkspaceKey(env: string, workspaceId: string) {
    return env + "::" + workspaceId;
}

export function getLDOrganizationKey(env: string, organizationId: string) {
    return env + "::" + organizationId;
}
